/**
 * 房源卡片
 * 
 * @Author: Focci
 * @Date: 2023-09-20 15:03:43
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-20 15:03:43
 */

import PropTypes from 'prop-types'
import ClaimedCard from '@comp/page/common/card/user/ClaimedCard'
import { pick } from 'lodash-es'
import { useMemo } from 'react'
import PropertyIcons from '@comp/page/common/card/property/PropertyIcons'

export default function TrackProperty({
  data = {}
}) {
  const property = useMemo(() => {
    const tmp = pick(data, ['slug', 'avm', 'address', 'bathrooms', 'bedrooms'])
    tmp.carspaces = data.carSpaces
    tmp.landarea = data.land_area
    tmp.floorarea = data.floor_area
    tmp.image = data.oss_cover

    return tmp
  }, [data])

  return (
    <ClaimedCard
      inline
      data={property}
      propertyIcons={
        <div className="ml-5 mt-3 mb-2">
          <PropertyIcons 
            data={property}
            iconWidth=".7rem"
          />
        </div>
      }
    />
  )
}

TrackProperty.propTypes = {
  data: PropTypes.object,
}
